export const emailActions = (state) => state.emailActions
export const placeholders = (state) => state.placeholders
export const totalEmailActions = (state) => state.totalEmailActions
export const selectAllField = (state) => state.selectAllField
export const selectedEmailActions = (state) => state.selectedEmailActions
